import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Item } from 'apis/restaurant-api/merchant-admin/menu2/types';
import MenuEditorSidepanel from 'modules/menu/components/MenuEditorSidepanel';
import { useVatCategories } from 'modules/menu/components/VatCategories';

import AddOrCopyItem from './AddOrCopyItem';
import { ItemConfiguration } from '../../../../apis/picker-api/types';

type Props = {
  itemToCopy?: Item;
  initialCategoryId: string | null;
  onSuccess: (itemId: string) => void;
  onClose: () => void;
  onItemConfigUpdated: (updatedConfigs: Record<string, ItemConfiguration>) => void;
};

const Content = styled.div`
  padding: 0 24px;
`;

const NewItemSidePanel = ({ itemToCopy, initialCategoryId, onSuccess, onClose, onItemConfigUpdated }: Props) => {
  const intl = useIntl();
  const { data: vatCategories } = useVatCategories();
  return (
    <MenuEditorSidepanel
      id={itemToCopy?.id || 'new-item'}
      title={intl.formatMessage({ id: 'menu-item.addItemHeader' })}
      onClose={onClose}
    >
      <Content>
        <AddOrCopyItem
          itemToCopy={itemToCopy}
          initialCategoryId={initialCategoryId}
          defaultVatCategoryCode={vatCategories?.default?.code}
          vatCategories={vatCategories?.list}
          onSuccess={onSuccess}
          onClose={onClose}
          onItemConfigUpdated={onItemConfigUpdated}
        />
      </Content>
    </MenuEditorSidepanel>
  );
};

export default NewItemSidePanel;
